import axios from 'axios'
import { getStoryblokApi } from '@storyblok/react'

import config from '../../config'

const { token, version } = config.storyblok

const StoryblokApi = axios.create({
  baseURL: 'https://api.storyblok.com/v2/cdn/',
  params: {
    token,
    version,
  },
})

const getStoryblokRequest = (endpoint, params = {}, lang = null) => {
  const sbApi = getStoryblokApi()

  const cv = window.localStorage.getItem('storyblok-cv')

  return async () => {
    const response = await sbApi.get(`cdn/${endpoint}`, {
      language: lang,
      version,
      cv,
      ...params,
    })

    return response
  }
}

const getAllStoryblokRequests = (allRequests, slug, lang) => {
  if (!allRequests[slug]) return false

  return (
    allRequests[slug] &&
    allRequests[slug].endpoints &&
    allRequests[slug].endpoints.map(async ({ url, params }) => {
      const request = await getStoryblokRequest(url, params, lang)
      return request()
    })
  )
}

export { StoryblokApi, getStoryblokRequest, getAllStoryblokRequests }
